/*
 *
 * Home actions
 *
 */

import {
  FLUSH_STATE_HOME
} from './constants';

/**
 * Clearing the state for Home
 */
export function flushStateHome() {
  return {
    type: FLUSH_STATE_HOME,
  };
}